import React from 'react';

const Cta = () => {
  return (
    <div className='max-w-7xl mx-auto px-4 sm:px-6 text-center mb-16'>
      <div className=' bg-highlight-eggshell p-8 md:p-20 rounded-md border-2 border-dotted border-text-main'>
        <h3 className='text-2xl md:text-5xl font-black leading-none mb-4 text-text-main'>
          It's time to <u>connect and learn</u> from other founders in Singapore.
        </h3>
        <p className='text-xl md:text-2xl text-text-main mb-8'>
          Don't miss out on this chance to connect with a supportive network of like-minded individuals. Join our
          community today!
        </p>
        <div className='mx-auto max-w-sm sm:max-w-none sm:flex sm:justify-center'>
          <a href='https://szuv34ek50v.typeform.com/to/W2b3Dq1h'>
            <button>
              <div className=' bg-primary-main hover:bg-primary-hover text-white py-4 px-4 md:px-10 rounded-full items-center'>
                <h3 className='text-xl md:text-2xl font-bold'>Claim your free trial</h3>
                <p className='text-xs sm:text-sm font-light'>Join a private community of {'>'}100 founders today.</p>
              </div>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default Cta;
